import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import PlusRound from "../../../assets/images/icons/PlusRound";
import { CustomIconStyle } from "../../../assets/styles/Button";
import useOutsideClick from "../../../hooks/useOutsideClick/useOutsideClick";
import {
  AdditionalMenuButton,
  AdditionalMenuTooltip,
} from "./AdditionalMenu.style";
import { useTranslation } from "react-i18next";
import SystemContext from "../../../context/systemContext";
import browserStorage from "../../../services/storage";
import AdditionalIcon from "../../../assets/images/icons/AdditionalIcon";
import { CustomStyledIconButton } from "../../../styles/global.style";
import RoleManager from "../../../services/roleManagement";

const AdditionalMenu = () => {
  const [show, setShow] = useState<boolean>(false);
  const target = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const [hasAccess] = RoleManager();

  const { t } = useTranslation();
  const { branchList } = useContext<any>(SystemContext);

  const closeMenu = () => setShow(false);

  const found = branchList.find(
    (b: any) => b?._id === browserStorage.get("branch")
  );

  // useOutsideClick(target, closeMenu);

  document.addEventListener("mousedown", (e: any) => {
    if (
      !e.target.classList.contains("addtional-menu-item") &&
      !e.target.classList.contains("text-decoration-none")
    ) {
      setShow(false);
    }
  });
  document.removeEventListener("mousedown", (e: any) => {
    if (
      !e.target.classList.contains("addtional-menu-item") &&
      !e.target.classList.contains("text-decoration-none")
    ) {
      setShow(false);
    }
  });
  useEffect(() => {
    console.log("------------rerender----------------");
  }, []);

  return (
    <div ref={target}>
      <CustomStyledIconButton onClick={() => setShow(!show)}>
        <AdditionalIcon />
      </CustomStyledIconButton>
      <Overlay target={target.current} show={show} placement="bottom">
        {(props) => (
          <AdditionalMenuTooltip id="additional-menu" {...props}>
            <ul className="addtional-menu-list p-0">
              <li
                className="addtional-menu-item"
                onClick={() => {
                  history.push("/orders/order-list");
                  setShow(false);
                }}
              >
                {t("ORDER.ADD_ORDER")}
              </li>
              {hasAccess("cashbox") && (
                <li
                  className="addtional-menu-item"
                  onClick={() => {
                    history.push("/finance/cash");
                    setShow(false);
                  }}
                >
                  {t("NAVIGATOR.CASH_DESK")}
                </li>
              )}
              {found?.ieltsRegistrationLink && (
                <a href={found?.ieltsRegistrationLink} target="_blank">
                  <li className="addtional-menu-item">
                    {t("GROUP.ieltsRegistrationLink")}
                  </li>
                </a>
              )}
            </ul>
          </AdditionalMenuTooltip>
        )}
      </Overlay>
    </div>
  );
};

export default memo(AdditionalMenu);
